module.exports = __webpack_public_path__ + "static/media/Group 2 Copy.a16524bc.png";